/**
 * Created by AlexanderC on 6/12/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidArnException = undefined;

var _Exception2 = require('../../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when ARN is invalid
 */
let InvalidArnException = exports.InvalidArnException = function (_Exception) {
  _inherits(InvalidArnException, _Exception);

  /**
   * @param {String} arn
   */
  function InvalidArnException(arn) {
    _classCallCheck(this, InvalidArnException);

    return _possibleConstructorReturn(this, (InvalidArnException.__proto__ || Object.getPrototypeOf(InvalidArnException)).call(this, `Invalid arn string "${arn}".`));
  }

  return InvalidArnException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/IAM/Exception/InvalidArnException.js
// module id = 358
// module chunks = 0